import type { JSX } from 'react';
import { useTranslation } from 'react-i18next';
import CustomTooltip from '../../../Components/Tooltip/CustomTooltip';
import DeleteIcon from '../../../bombiix-icon/DeleteIcon';
import { NewInput } from '../../../Components/PIM/common';

interface FilterValueRowValue {
  label: string;
}

interface FilterValueRowProps {
  value: FilterValueRowValue;
  error?: string | undefined;
  onChange: (label: string) => void;
  onDelete: () => void;
  masterAddEditAccess: boolean;
  masterDeleteAccess: boolean;
  maxLength: number;
}

function FilterValueRow({ value, error, onChange, onDelete, masterDeleteAccess, masterAddEditAccess, maxLength }: FilterValueRowProps): JSX.Element {
  const { t } = useTranslation('systemMaster');

  const isInvalid = error !== undefined;

  return (
    <li>
      <div className="filter-value-field">
        <NewInput
          value={value.label}
          maxLength={maxLength}
          onChange={(e) => onChange(e.target.value)}
          disabled={!masterAddEditAccess}
          invalid={isInvalid}
          aria-invalid={isInvalid}
          placeholder={t('ASSET_LIBRARY.ENTER_VALUE')}
        />
      </div>
      <div className="input-action">
        {masterDeleteAccess && (
          <CustomTooltip tooltipText={t('ASSET_LIBRARY.DELETE')}>
            <button type="button" aria-label="Delete" onClick={onDelete} className="bombiix-icon-container bombiix-icon-container--inactive">
              <DeleteIcon size={20} />
            </button>
          </CustomTooltip>
        )}
      </div>
    </li>
  );
}

export default FilterValueRow;
